import {Signal} from "@angular/core";

export abstract class BackNavigationService {
  // Whether the most recent navigation was a back navigation (navigateBack() or a
  // browser/Location.back() popstate). Authoritative source for direction-aware
  // behaviour such as transition animations and scroll-position restoration.
  abstract readonly lastNavigationWasBack: Signal<boolean>;
  abstract initialize(): void;
  abstract navigateBack(): void;
}
